export default __webpack_public_path__ + "static/kathi_hand-4f465207cf1cebaa49780c9cfce2df0e.png";